import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking">
                <div className="font-heading text-3xl text-[var(--lk-primary)] lk-pulse">Lakshmi</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    return children;
}
